import { lazy } from 'react';

export default lazy(
  () =>
    import(
      /* webpackChunkName: "deal-details-view" */
      './CustomerGroupDetails'
    )
);
